import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';

import { clearModal } from '@shoflo/studio-redux/actions';

import { createStreamEndpoint, updateStreamEndpoint } from 'actions/Broadcast';

import ModalHeader from 'components/Modal/Header';
import { ENDPOINT_FORM } from 'constants/ModalTypes';
import UnconnectedStreamEndpointForm from 'components/StreamEndpointForm/StreamEndpointForm';

const StreamEndpointForm = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === ENDPOINT_FORM
  );

  const currentEndpoint = useSelector(({ modal }) =>
    modal ? modal.initialValue : null
  );
  const title = `${currentEndpoint ? 'Edit' : 'Add'} RTMP stream`;

  const dispatch = useDispatch();

  const clearThisModal = () => dispatch(clearModal(ENDPOINT_FORM));

  const handleSubmit = endpoint => {
    if (currentEndpoint) {
      return dispatch(updateStreamEndpoint(endpoint, currentEndpoint));
    }

    dispatch(createStreamEndpoint(endpoint));
  };

  return (
    <Modal isOpen={isOpen} toggle={clearThisModal}>
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <UnconnectedStreamEndpointForm
          onSubmit={endpoint => {
            clearThisModal();
            handleSubmit(endpoint);
          }}
          onCancel={clearThisModal}
          endpoint={currentEndpoint}
        />
      </ModalBody>
    </Modal>
  );
};

export default StreamEndpointForm;
